<template>
    <DxDataGrid :data-source="dsTipRetineri" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id" @editor-preparing="onEditorPreparing">
        <DxSelection mode="single" />
        <DxFilterRow :visible="true" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" :width="350" :height="310" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid :col-count="1">
                <DxItem data-field="Nume" :editor-options="{ height: 50 }"/>
                <DxItem 
                    data-field="BindSalarii" 
                    editor-type="dxLookup"
                    :editor-options="{ 
                        dataSource: SAL_Input,
                        valueExpr: 'Cod',     
                        displayExpr: 'Name',
                        searchEnabled: true,
                        showClearButton: true,
                        height: 50
                    }"
                />
            </DxFormGrid>
        </DxEditing>
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Tip Retinere
            </div>
        </template>

        <DxColumn data-field="Nume" caption="Nume"/>
        <DxColumn data-field="BindSalarii" caption="Variabila Intrare Salarii" cell-template="variabila" :filter-operations="['=']"/>
        <template #variabila="{ data }">
            <div>{{ getSalInputName(data.value) }}</div>
        </template>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="350" height="310">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Tip Retinere
            </div>
        </template>
        <DxForm :col-count="1" :data-dource="newTip">
            <DxSimpleItem data-field="Nume">
                <template #default>
                    <DxTextArea :value="newTip.Nume" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Variabila Intrare Salarii">
                <template #default>
                    <DxLookup :data-source="SAL_Input" 
                            :value="newTip.BindSalarii"
                            value-expr="Cod"
                            display-expr="Name"
                            :showClearButton="true"
                            :searchEnabled="true"
                            height="50px"
                            @value-changed="onBindValueChanged"/>
                    <DxDropDownOptions :show-title="false" />
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
    import {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxPopup,
        DxItem,
        DxItem as DxFormItem,
        DxForm as DxFormGrid,
        DxValidationRule,
        DxRequiredRule,
        DxSearchPanel,
    } from 'devextreme-vue/data-grid';
    import DxDateBox from 'devextreme-vue/date-box';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import DxTextArea from 'devextreme-vue/text-area';
    import AppSetting from '@/settings/appSettings';
    import { defineComponent, ref } from 'vue';
    import DataSource from 'devextreme/data/data_source';
    import { DxButton } from 'devextreme-vue/button';
    import notify from 'devextreme/ui/notify';
    import { DxForm, DxSimpleItem } from "devextreme-vue/form"
    import DxPopupAdd from 'devextreme-vue/popup'
    import { DxToolbarItem } from 'devextreme-vue/popup';
    import { DxNumberBox } from "devextreme-vue/number-box";
    import { DxSelectBox } from 'devextreme-vue/select-box';
    import { DxLookup, DxDropDownOptions } from 'devextreme-vue/lookup';
    import RU_TipRetinere from '@/services/RU/RU_TipRetinere';

    export default defineComponent({
        components: {
            DxColumn,
            DxDataGrid,
            DxFilterRow,
            DxLoadPanel,
            DxPaging,
            DxSelection,
            DxSorting,
            DxStateStoring,
            DxToolbar,
            DxEditing,
            DxValidationRule,
            DxRequiredRule,
            DxItem,
            DxButton,
            DxSearchPanel,
            DxForm,
            DxPopupAdd,
            DxSimpleItem,
            DxTextArea,
            DxCheckBox,
            DxToolbarItem,
            DxPopup,
            DxFormGrid,
            DxFormItem,
            DxDateBox,
            DxNumberBox,
            DxSelectBox,
            DxLookup,
            DxDropDownOptions
        },
        data() {
            return {
                dsTipRetineri: {} as DataSource,
                SAL_Input: new DataSource({
                    store: {
                        type: 'odata',
                        url: AppSetting.API_Url_ResurseUmaneOdata + `SAL_Input`,
                        key: 'Id',
                        keyType: "Guid",
                        version: 4,
                        beforeSend: (e: any) => {
                            e.headers = {
                                "Content-Type": "application/json",
                                "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                            };
                        }
                    },
                    filter: ["Tip", "=", "A"],
                    sort: [{ selector: "Name", desc: false }] 
                }),
                newTip: {
                    Nume: '',
                    BindSalarii: ''
                },
                addPopupVisible: false,
                dataGridRef: ref<DxDataGrid | null>(null),
                deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
                addButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveAdd()
                    }
                },
                saveButtonOptions: {
                    type: "success", 
                    text: "Salvează", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onSaveEdit()
                    }
                },
                closeButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.onCloseAdd()
                    }
                },
                dangerButtonOptions: {
                    type: "danger", 
                    text: "Închide", 
                    stylingMode: "contained",
                    onClick: () => {
                        this.closeEditPopup()
                    }
                }, 
                localSalInputCache: [] as any[],
            }
        },
        async mounted() {
            this.dsTipRetineri = new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `RU_TipRetinere`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            })
            this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
            this.setDeleteConfirmationMessage()
            const store = this.SAL_Input.store();
            try {
                this.localSalInputCache = await store.load(); 
            } catch (e) {
                console.error("Failed to load SAL inputs for template", e);
            }
        },
        methods: {
            onEditorPreparing(e: any) {
                if (e.parentType === 'filterRow' && e.dataField === 'BindSalarii') {
                    
                    e.editorName = 'dxSelectBox';
                    e.editorOptions.dataSource = {
                        store: this.SAL_Input.store(),
                        sort: [{ selector: "Name", desc: false }]
                    }
                    e.editorOptions.valueExpr = 'Cod';
                    e.editorOptions.displayExpr = 'Name';
                    e.editorOptions.showClearButton = true;
                    e.editorOptions.searchEnabled = true;
                    e.editorOptions.placeholder = 'Selectati...';
                    
                    e.editorOptions.onValueChanged = (args: any) => {
                        e.setValue(args.value); 
                    };
                }
            },
            setDeleteConfirmationMessage() {
                const dataGrid = this.$refs.dataGridRef?.instance;
                dataGrid.option('editing', {
                    allowUpdating: true,
                    allowDeleting: true,
                    mode: 'popup',
                    texts: {
                        confirmDeleteMessage: this.deleteConfirmationMessage,
                        confirmDeleteTitle: "Confirmare Ștergere",
                    }
                });
            },
            getSalInputName(code: string) {
                if (!code || this.localSalInputCache.length === 0) return code;
                
                const item = this.localSalInputCache.find(x => x.Cod === code);
                return item ? item.Name : code; 
            },
            onRefreshClick() {
                const gridInstance = this.dataGridRef?.instance;
                if (gridInstance) {
                    gridInstance.refresh();
                    notify("Datele au fost actualizate cu succes!", "success", 3000);
                }
            },
            onAddClick() {
                this.addPopupVisible = true
            },
            onCloseAdd() {
                this.addPopupVisible = false
                this.newTip = {
                    Nume: '',
                    BindSalarii: ''
                }
            },
            closeEditPopup() {
                this.dataGridRef?.instance?.cancelEditData();
            },
            async onSaveEdit() {
                const gridInstance = this.dataGridRef?.instance;
                if (!gridInstance) {
                    notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                    return; 
                }
                try {
                    gridInstance.saveEditData()
                    notify('Datele au fost salvate cu succes!', 'success', 2000);
                } catch (error: any) {
                    console.error("Eroare la salvarea editării:", error);
                }
            },
            onNumeValueChanged(e: any) {
                this.newTip.Nume = e.value
            },
            onBindValueChanged(e: any) {
                this.newTip.BindSalarii = e.value
            },
            onSaveAdd() {
                if (!this.newTip.Nume || this.newTip.Nume.trim() === "") {
                    notify("Vă rog să completați câmpul obligatoriu 'Nume'!", "error", 3000)
                    return
                }

                if (!this.newTip.BindSalarii || this.newTip.BindSalarii.trim() === "") {
                    notify("Vă rog să completați câmpul obligatoriu 'Variabila Intrare Salarii'!", "error", 3000)
                    return 
                }

                RU_TipRetinere.save(this.newTip).then((tip) => {
                    this.addPopupVisible = false
                    notify('Datele au fost salvate cu succes!', 'success', 2000)
                    this.newTip = {
                        Nume: '',
                        BindSalarii: ''
                    }
                    this.onRefreshClick()
                }).catch((error) => {
                    console.error(error)
                })
            }
        }
    })
</script>